import { render, staticRenderFns } from "./FuiGroup.vue?vue&type=template&id=c156897c&"
import script from "./FuiGroup.vue?vue&type=script&lang=js&"
export * from "./FuiGroup.vue?vue&type=script&lang=js&"
import style0 from "./FuiGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports